import { CaseReducer, createReducer, UnknownAction } from '@reduxjs/toolkit';

import { ILookupState } from 'app/models';
import { cacheLookup, clearLookup } from './actions';

const defaults: ILookupState = {};

export { ELookup, utils } from './options';
export { cacheLookup, clearLookup, fetchLookup, reloadLookup, type IFetchOptions } from './actions';
export { getLookup } from './selectors';

export default createReducer(defaults, (builder) => {
  builder.addCase(cacheLookup, (state, { payload }) => ({ ...state, ...payload }));
  builder.addCase(clearLookup, () => defaults);

  const commands = new Map<string, CaseReducer<ILookupState>>();
  commands.set('lookup/reload', (state, { payload }) => (payload ?? state) as ILookupState);

  builder.addMatcher<UnknownAction>(({ type }) => commands.has(type), (state, action) => {
    return commands.get(action.type)!(state, action);
  });
});
